import {Link} from "react-router-dom";
import React from "react";
import "./sidebar.scss"
import BackDrop from "../backdrop/backdrop";
import useMediaQuery from '@mui/material/useMediaQuery';
import UserCredit from "../usercredit/usercredit";
import PanelChange from "../panelchange/panelchange";

interface ISideBar {
    open: boolean;
    close: () => void;
    credit?: string;
    inside: JSX.Element;
    panelChangeTarget: string
    panelChangeTitle: string
}

const SideBar = ({open, close, credit, inside, panelChangeTarget, panelChangeTitle}: ISideBar) => {
    let attachedClasses = ["SideBar", "Close"];
    const matches = useMediaQuery('(max-width:768px)');
    if (open) {
        attachedClasses = ["SideBar", "Open"];
    }
    return (
        <>
            <BackDrop type="Normal" close={close} show={open}/>
            <div className={attachedClasses.join(" ")}>
                <div className="d-flex flex-column justify-content-between align-items-center h-100">
                    <div className="SideBar-Content-Container">
                        <div className="SideBar-Logo">
                            <Link className="mx-auto" to="/">
                                <img src={require("../../assets/images/Logo2.png")} alt="Logo"
                                     className="img-fluid SideBar-Logo-Image"/>
                            </Link>
                        </div>
                        {matches && credit ? <UserCredit credit={credit}/> : null}
                        {inside}
                    </div>
                    <PanelChange title={panelChangeTitle} target={panelChangeTarget}/>
                </div>
            </div>
        </>
    );
}

export default SideBar